import { Dispatch, createSlice } from "@reduxjs/toolkit";

interface DriverState {
  allPools: any;
  poolsWallet: any;
  globalPoolData: any;
  userPoolData: any;
}

const initialState: DriverState = {
  allPools: [],
  poolsWallet: [],
  globalPoolData: [],
  userPoolData: []
};

const poolSlice = createSlice({
  name: "poolSlice",
  initialState,
  reducers: {
    getAllPools(state, action) {
      state.allPools = action.payload;
    },
    getPoolsWallet(state, action) {
      state.poolsWallet = action.payload;
    },
    getGlobalPoolData(state, action) {
      state.globalPoolData = action.payload;
    },
    getUserPoolData(state, action) {
      state.userPoolData = action.payload;
    }
  },
});

export function getDataAllPools(data: any) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(poolSlice.actions.getAllPools(data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function getGlobalPoolData(data: any) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(poolSlice.actions.getGlobalPoolData(data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function getUserPoolData(data: any) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(poolSlice.actions.getUserPoolData(data));
    } catch (error) {
      console.log(error);
    }
  };
}


export function getDataPoolsWallet(data: any) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(poolSlice.actions.getPoolsWallet(data));
    } catch (error) {
      console.log(error);
    }
  };
}

const poolReducer = poolSlice.reducer;

export default poolReducer;
